// extracted by mini-css-extract-plugin
module.exports = {"container":"_1410bfd27b--container--C8t76","slide":"_1410bfd27b--slide--b2JzW"};